import { render, staticRenderFns } from "./RespLoginModal.vue?vue&type=template&id=15840b40&scoped=true&"
import script from "./RespLoginModal.vue?vue&type=script&lang=js&"
export * from "./RespLoginModal.vue?vue&type=script&lang=js&"
import style0 from "./RespLoginModal.vue?vue&type=style&index=0&id=15840b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15840b40",
  null
  
)

export default component.exports